import React, { useCallback, useEffect } from 'react';

import styled, { css } from 'styled-components';

import { Button, mobile } from '~/techstyle-shared/react-components';
import { FormattedMessage, useIntl } from '~/techstyle-shared/react-intl';

import QuickView from '../QuickView';

import errorMessages from './errorMessages';
import {
  useProductDetailCTAContext,
  ProductDetailCTAErrorTypes,
} from './ProductDetailCTAContext';

const UpdateBagButton = styled(Button).attrs({
  variant: 'primaryAddToBag',
})`
  border-radius: 4px;

  ${mobile`
    margin-top: 16px;
  `}
`;

const labelStyle = css`
  font-size: 18px;
  font-weight: bold;
  letter-spacing: ${-0.4 / 18}em;
  color: ${({ theme }) => theme.colors.textLight};
`;

function UpdateBagCTA() {
  const intl = useIntl();

  const { cartItem } = QuickView.useContext();
  const {
    addToCart,
    handleSharedValidation,
    isLoading,
    setErrorMessage,
    onSuccessfulAddToCart,
    deleteFromCart,
    hasError,
  } = useProductDetailCTAContext();
  const disabled = isLoading;

  useEffect(() => {
    if (!hasError) {
      setErrorMessage(null);
    }
  }, [hasError, setErrorMessage]);

  const handleCTAClick = useCallback(async () => {
    try {
      await handleSharedValidation();
      await deleteFromCart(cartItem);
      await addToCart({ applyMemberCredit: cartItem.tokenQtyApplied > 0 });
      onSuccessfulAddToCart && onSuccessfulAddToCart();
    } catch (error) {
      if (error.message === ProductDetailCTAErrorTypes.SelectorError) {
        setErrorMessage(intl.formatMessage(errorMessages.sizeSelectorError));
      }
    }
  }, [
    handleSharedValidation,
    deleteFromCart,
    cartItem,
    addToCart,
    onSuccessfulAddToCart,
    setErrorMessage,
    intl,
  ]);

  return (
    <UpdateBagButton
      data-autotag="update-bag"
      labelStyle={labelStyle}
      onClick={handleCTAClick}
      disabled={disabled}
    >
      <FormattedMessage
        id="app_pdp.update_in_bag"
        defaultMessage="Update in Bag"
      />
    </UpdateBagButton>
  );
}

export default UpdateBagCTA;
